'use client';

import { CancelAutoRenewalModal } from '../../CancelAutoRenewalModal/CancelAutoRenewalModal';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

/**
 * Renders the cancel auto-renewal modal for renewable tickets.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsCancelModal() {
  const { ticket, hasRenewal, lastDrawDate, isCancelModalOpen, isCancelling, closeCancelModal, handleCancelConfirm } = usePurchaseDetails();
  const { activeSince, totalWinning } = ticket;

  if (!hasRenewal || !activeSince) return null;

  return (
    <CancelAutoRenewalModal
      isOpen={isCancelModalOpen}
      onClose={closeCancelModal}
      onConfirm={handleCancelConfirm}
      totalWinnings={totalWinning > 0 ? totalWinning : undefined}
      startDate={new Date(activeSince)}
      lastDrawDate={new Date(lastDrawDate)}
      isLoading={isCancelling}
    />
  );
}

export { PurchaseDetailsCancelModal };
